<template>
  <section class="popup-item">
    <icon-component
      class="popup-icon"
      name="hamburger"
      @click="toggleActive($event)"
    />
    <div class="popup-wrapper">
      <transition name="fade">
        <div class="popup-menu" v-show="shown">
          <div
            class="menu-item"
            v-for="(action, index) in actions"
            :key="index"
            @click="action.click"
          >
            <div v-if="action.icon">
              <icon-component :name="action.icon" />
            </div>
            <div>
              {{ action.title }}
            </div>
          </div>
        </div>
      </transition>
    </div>
  </section>
</template>

<script>
import IconComponent from "@/common/ui/IconComponent";
export default {
  name: "MenuComponent",
  components: { IconComponent },
  props: {
    actions: {
      type: Array,
      default: () => []
    }
  },
  data: () => ({
    shown: false
  }),
  methods: {
    toggleActive() {
      const closePopup = () => {
        if (this.shown) {
          this.shown = false;
        }
      };
      if (!this.shown) {
        setTimeout(() => {
          document.addEventListener("click", closePopup, { once: true });
          this.shown = true;
          document.querySelectorAll(".popup-menu").forEach((item, idx, arr) => {
            arr.length === 1 && arr[0]?.classList.add("popup-menu--one");
            arr.length !== 1 && arr[arr.length - 1] &&
              arr[arr.length - 1]?.classList.add("popup-menu--last");
            arr[arr.length - 3] &&
              arr[arr.length - 3]?.classList.add("popup-menu--midl");
          });
        }, 10);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.popup-item {
  .popup-icon {
    cursor: pointer;
  }
  .popup-wrapper {


    .popup-menu {
      position: absolute;
      background: #fff;
      border: 1px solid rgba(200, 200, 200, 0.2);
      border-radius: 12px;
      z-index: 999999;
      &--last {
        bottom: 0;
      }

      .menu-item {
        padding: 8px 16px;
        cursor: pointer;
        display: flex;
        align-items: center;
        gap: 8px;
        .icon {
          width: 16px;
        }
        &:hover {
          background: rgba(200, 200, 200, 0.2);
        }
      }
    }
  }
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
